export default async function getChamadoByRegistroId(registroId) {
    try {
        const userSession = JSON.parse(sessionStorage.getItem('user'));

        if (!userSession || !userSession.token) {
            throw new Error("Dados insuficientes no sessionStorage.");
        }

        const { token } = userSession;
        
        // Faz a requisição para a API de chamados
        const response = await fetch(`https://server-cmd-automacao.vercel.app/chamados/${encodeURIComponent(registroId)}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`Erro ao buscar chamado: ${response.statusText}`);
        }

        const data = await response.json();

        // Verifica se os dados retornados são válidos
        if (!data || !data.chamado) {
            throw new Error("Resposta inválida da API ou chamado não encontrado.");
        }

        return data; // Retorna os dados do chamado e dos registros
    } catch (error) {
        return { chamado: null, registros: [] }; // Retorna um objeto padrão em caso de erro
    }
}
